import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white py-4">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="group">
          <img 
            src="/images/nome coopdelta.png" 
            alt="Logo COOPDELTA" 
            className="h-5 w-auto object-contain transition-all duration-300 group-hover:scale-105 drop-shadow-lg"
          />
        </div>
        <div className="text-sm text-white/70">
          © {new Date().getFullYear()} COOPDELTA. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;